// import React, { useState } from 'react';
// import ReactDOM from 'react-dom';
// import Editor from './../Editor';
import EventBind from './EventBind.js';
import EditApi from './EditApi.js';
import Api from '../Api/Api.js';
import { SocketService } from "../Api/SocketService.js";
import { patternSocket } from "../Utils/lvsSocket.js";
import SocketEvent from '../Api/SocketEvent.js';
import axios from 'axios';
import QRcode from "qrcode";
import orderUtil from '../Utils/orderUtil.js';
import FormatTime from '../Utils/TimeFormat.js';
axios.defaults.headers.post['Content-Type'] = 'application/json';

let socketServiceInstanct = null;//初始化socket
let hasRepeatSocket = false;//检查是否有通道
let isPlay = false;//是否播放状态
let hasPattern = false;//是否有上传过的文件
let PatternStatus = 0;//是否有上传过的文件,0 没有对应pattern id,1 有对应的ID但是没创建数据，2有ID也有数据
let diffTime =  0;//获取服务器时间，并修正本地时间
let editorInfo = {
    type:1,//1客户二维码  2创作者二维码,funscript默认为客户二维码
}
// let isWaiting = {//是否在视频缓冲状态
//   waiting:false,
//   t:0,
// }
let isConnect = null //是否同步玩具
let getConnect = null //轮询是否同步玩具
let isLoad = false //是否成功获取Pattern
let getLoad = null //轮询是否成功获取Pattern
let connectToyStatus = 1;//玩具链接状态，1未连接 2连接中 3已连接
  // let followStatus = false;

//Pattern编辑器组件API暴露 

// 在线文档：https://developer.lovense.com/proposal/video-pattern.html#

/**
 * 暴露init接口
 * @method init
 * @param {String} [uid] 平台使用k，v值通过AES加密生成 (必填)
 * @param {String} [token] 平台token (必填)
 * @param {String} [pf] 平台名称 (必填)
 * @param {String} [mediaId] 平台需要播放pattern的媒体id
 * @param {number} [duration] 媒体总时长(毫秒)
*/
let init = (data) =>{
  if (data.mediaId) {
    editorInfo.videoId = data.mediaId;
  }
  editorInfo = {...editorInfo,...data};
  const checkRes = checkParams(editorInfo);
  const checkUse = checkUsePattern(editorInfo);
  connectToyStatus = 1
  isLoad = false
  isConnect = false
  if (checkRes) {
      //判断是否有传videoId参数，如果有，就使用我们的patter,如果没有，就走funscript流程
      if (checkUse) {
          //使用我们的patter，未对接
      } else {
          //使用funscript
          SetSocketService();
          setTimeout(()=>{
            if(socketServiceInstanct){
              socketServiceInstanct.getSyncStatus();
              socketServiceInstanct.socketEmitMsg('ModifyVideoPatternDTO', {});
            }
          }, 300);
          EventBind.removeEventListenerAll();
          setDiffTime((data)=>{
            diffTime = data;
          });
          getPattern();
      }
  }
}
/**
 * 暴露loadPattern接口
 * @method loadPattern
 * @param {String} [type] pattern类型(funScript/lovense)
 * @param {Array} [data] pattern数组
 * @param {String} [patternLink] pattern在线地址
*/
let loadPattern = async(loadPatternParams) =>{
  let newArr = [];
  switch (loadPatternParams.type) {
      case 'funScript':
          if(loadPatternParams.data && loadPatternParams.data.length){
            loadPatternParams.data.forEach((item) => {//生成自己的格式类型
                let value = {//取整，v值为0-20，t值为100最小单位
                    v:Math.round(Number(item['pos'])/5),
                    // t:(Number(item[Object.keys(item)[1]])/1000).toFixed(1)*1000
                    t:Number(item['at'])
                }
                editorInfo.loadType = "funScript"
                newArr.push(value)
            });
            uploadPattern(newArr)
            break;
          }
          if(!loadPatternParams.patternLink){
            console.error(" Can't Find Lovense Pattern for this media, the data can't be empty");
            return false;
          }
          try {
            const { data } = await axios.get(loadPatternParams.patternLink);
            data.actions.forEach((item) => { //生成自己的格式类型
                let value = {//取整，v值为0-20，t值为100最小单位
                    v: Math.round(Number(item['pos'])/5),
                    t: Number(item['at'])
                }
                editorInfo.loadType = "funScript"
                newArr.push(value)
            });
            uploadPattern(newArr)
          } catch (error) {
            console.error(" Unable to read file");
            return false;
          }
          
          break;
      case 'lovense':
        if (loadPatternParams.data&&loadPatternParams.data.length) {
            newArr = loadPatternParams.data;
            editorInfo.loadType = "lovenseData"
            uploadPattern(newArr)
        } else {
          if(loadPatternParams.patternLink){
            try {
                const { data } = await axios.get(loadPatternParams.patternLink);
                newArr = data
                editorInfo.loadType = "patternLink"
                uploadPattern(newArr)
            } catch (error) {
                console.error(" Unable to read file");
                return false;
            }
            break;
          }
          if (editorInfo.patternData&&PatternStatus===2) {
            if(isLoad) {
                newArr = editorInfo.patternData;
                editorInfo.loadType = "lovenseGetId"
                uploadPattern(newArr)
            } else {
                clearInterval(getLoad)
                getLoad = setInterval(() => {
                    if(isLoad) {
                        newArr = editorInfo.patternData;
                        editorInfo.loadType = "lovenseGetId"
                        uploadPattern(newArr)
                        clearInterval(getLoad)
                    }
                }, 200)
                return
            }
          } else if (PatternStatus===0) {
             console.error(" Can't Find Lovense Pattern for this media, Please create it from the Lovense Pattern editor page first.");
             return false;
          }else if (PatternStatus===1){
            console.error(" Can't Find Lovense Pattern for this media, the data can't be empty");
            return false;
          }
        }
        break;
  
      default:
          console.error('type is error!');
          return false;
  }
}
/**
 * 暴露监听事件pattern loaded
 * @method on
 * @param {String} [eventKey] 监听的事件
 * @param {Function} [callback] 回调函数
*/
let on = (eventKey,callback) =>{
  EventBind.addEventListener(eventKey,callback)
}
/**
 * 暴露监听事件pattern loaded
 * @method addEventListener
 * @param {String} [eventKey] 监听的事件
 * @param {Function} [callback] 回调函数
*/
let addEventListener = (eventKey,callback) =>{
  EventBind.addEventListener(eventKey,callback)
} 
/**
 * 暴露获取二维码和打开APP链接的接口
 * @method getApp
 * @param {Function} [callback] 回调函数
*/
let getApp = (callback) =>{
  let param = JSON.stringify({
      videoId: editorInfo.videoId,
      uid: editorInfo.uid,
      pf: editorInfo.pf,
      type: editorInfo.type,//1客户二维码  2创作者二维码
    });
    axios.post(Api.getQrCode, param).then(function (response) {
          const res = response.data;
          if(res && res.code === 0){
            let u = navigator.userAgent;
          let isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
          if(isWeixin){
            alert("Please open in your browser!");
            return;
          }
          let url = "https://lovense.club/remote/camapi/vpEvokeApp.html?vpCode=" + res.data.code + "&time=5000";
          QRcode.toDataURL(res.data.qrCode, {
              type: "image/png", //类型
              quality: 0.5, //图片质量A Number between 0 and 1
              width: 140,   //高度
              height: 140,  //宽度
              errorCorrectionLevel: "L", //容错率
              margin: 2,   //外边距
              color: {
                dark: "#000", //前景色
                light: "#fff" //背景色
              }
            }).then(imgData => {
              createRecord("get_qrcode");
              callback({
                qrCode:imgData,
                appOpenUrl:url,
                code: res.data.code
              })//这里测试用返回图片url，正式环境只返回qrcode
            })
          // callback(res.data)
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}
/**
 * 暴露play接口
 * @method play
 * @param {string} [speed] 播放速度
 * @param {string} [currentTime] 当前播放时间
*/
let play = (data) =>{
  editorInfo.speed = data.speed;
  editorInfo.currentTime = data.currentTime;
  isPlay = true;
  if(connectToyStatus === 3){
      let ts = (new Date().getTime()) + diffTime;
      let videodata = { videoTime:data.currentTime,speed:data.speed,localTime: ts};
      let type = SocketEvent.StartWatchVideoStatusDTO;
      socketServiceInstanct.socketEmitMsg(type, videodata);
  }
}
/**
 * 暴露pause接口
 * @method pause
*/
let pause = () =>{
    isPlay = false;
    if(connectToyStatus === 3){
        let type = SocketEvent.StopWatchVideoStatusDTO;
        socketServiceInstanct.socketEmitMsg(type, {});
    }
}
/**
 * 暴露change接口
 * @method change
 * @param {string} [speed] 播放速度
 * @param {string} [currentTime] 当前播放时间
*/
let change = (data) =>{
    editorInfo.speed = data.speed;
    editorInfo.currentTime = data.currentTime;
    // if(isWaiting.waiting && isWaiting.t > 0){//如果有卡顿，就延迟播放
    //   let now = new Date().getTime();
    //   if(now - isWaiting.t > 300){
    //     isWaiting.waiting = false;
    //     isWaiting.t = 0;
    //     ExportApi.play(data);
    //   }
    // }
    if(isPlay && socketServiceInstanct && connectToyStatus === 3){//正常播放响应
      socketSendVideoInfo(data);
    }
}
/**
 * 暴露断开链接接口
 * @method exit 
*/
let exit = () =>{
  isPlay = false;
  if(connectToyStatus === 3){
      let type = SocketEvent.PcExitPatternSyncDTO;
      socketServiceInstanct.socketEmitMsg(type, {});
      EventBind.emitEvent('remoteExitPattern')
  }
}
/**
 * 初始化Pattern编辑器
 * @method editInit 
 * @param {string} [uid] 平台使用k，v值通过AES加密生成 (必填)
 * @param {string} [pf] 平台名称 (必填)
 * @param {string} [token] 平台token (必填)
 * @param {string} [mediaId] 平台需要创建pattern的媒体id (必填mediaId/videoId之一)
 * @param {string} [domId] Pattern编辑器将会挂载到此id的元素上 (必填)
 * @param {videoObject} [videoEl] video标签dom元素，Pattern编辑器与视频关联 (必填)
 * @param {number} [editorWidth = 980] Pattern编辑器的宽度 目前仅支持px
 * @param {number} [useRole = 1] 用户角色：1创作者，2普通用户
*/
let editInit = (data) => {
    data.token = 1 // 还没有实装token操作，先给个默认值
    if(!data.videoId && !data.mediaId){
        console.error("Missing parameter videoId or mediaId!");
        return false
    }
    const requireArr = ['uid', 'pf', 'token', 'domId', 'videoEl']
    for (let i = 0; i < requireArr.length; i++) {
        const row = requireArr[i];
        if(!data[row]){
            console.error(`Missing parameter ${row} !`)
            return false
        }
    }
    const { uid, pf, videoId, mediaId, videoEl, domId, editorWidth = 980, role = 1 } = data
    let speed = videoEl.playbackRate
    let obj = new EditApi()
    obj.init(uid, pf, videoId || mediaId, videoEl, domId, editorWidth, role, speed)
    videoEl.onratechange = () => {
        obj.setSpeed(videoEl.playbackRate)
    }
}

// ExportApi.waiting = (data) =>{//暴露waiting接口
//   if(data.currentTime > 0){
//      //一个奇怪的问题：
//     //当视频播放完毕后再点击播放按钮，此时video标签会先onPlay,再触发waiting
//     //但是此时视频还是正常播放，而我却发送了暂停事件给服务端
//     //故这里用播放进度>0才对waiting做处理
//     ExportApi.pause();
//     isWaiting.waiting = true;
//     isWaiting.t = new Date().getTime();
//   }
// }
//参数校验
function checkParams(editorInfo){
    if(!editorInfo.uid){
      console.error("Missing parameter uid !");
      return false;
    }
    if(!editorInfo.token){
      console.error("Missing parameter token !");
      return false;
    }
    if(!editorInfo.pf){
        console.error("Missing parameter pf !");
        return false;
    }
    if(!editorInfo.videoId&&!editorInfo.mediaId){
        console.error("Missing parameter videoId or mediaId!");
        return false;
    }
    return true;
};
//确认是否使用我们的pattern
function checkUsePattern(editorInfo){
    if(!editorInfo.videoId||!editorInfo.videoEl||!editorInfo.domId||!editorInfo.editorWidth||!editorInfo.role||!editorInfo.speed){
      return false;//不使用
    }
    return true;//使用
};
//发送视频播放信息
function socketSendVideoInfo(data) {
  
  if(connectToyStatus === 3&& isPlay){
    let ts = (new Date().getTime()) + diffTime;
    let videodata = { videoTime:data.currentTime,speed:data.speed,localTime: ts};
    let type = SocketEvent.VideoProgressStatusDTO;
    socketServiceInstanct.socketEmitMsg(type, videodata);
  }
}
async function getPattern() {
    let url = Api.getPattern + "?videoId=" + editorInfo.videoId + "&pf=" + editorInfo.pf;
    let res = await axios.get(url);
    if(res.data && res.data.code === 0){ //已存在pattern，则显示曲线
      hasPattern = true;
      editorInfo.patternId = res.data.data.id;
      let patternUrl = res.data.data.pattern;
      let res2 = await axios.get(patternUrl)
      editorInfo.patternData = res2.data;
      PatternStatus = 2;
      isLoad = true
    }else if (res.data.code === 10031) {
      PatternStatus = 0;
    }else if (res.data.code === 10030) {
      PatternStatus = 1;
    }else{
      console.log(res.data.message);
    }
}
function createRecord(params) {
  let osInfo = orderUtil.getOsInfo();
    let param = JSON.stringify({
      videoId: editorInfo.videoId,
      pf: editorInfo.pf,
      uid: editorInfo.uid,
      videoDuration: parseInt(editorInfo.duration/1000),
      videoUrl: window.location.href,
      videoName: "",
      system: osInfo.name + " " + osInfo.version,
      browser: osInfo.browser,
      eventId: params,
    });
    axios.post(Api.createRecord, param).then(function (res) {
      if(res.data && res.data.code === 0){ }
    });
}
function editPattern(fileUrl) {
  let param = JSON.stringify({
    patternId: editorInfo.patternId,
    pattern: fileUrl,
    pf: editorInfo.pf,
    uid: editorInfo.uid,
    loadType:editorInfo.loadType
  });
  axios.post(Api.editPattern, param).then(function (res2) {
    if(res2.data.code === 0){
      
    }
  })
  .catch(function (error) {
    console.log(error);
  });
}
function uploadPattern(newArr) {
  var formData = new FormData();
  formData.append('uid', editorInfo.uid);
  formData.append('pf', editorInfo.pf);
  formData.append('loadType', editorInfo.loadType);
  formData.append('file', new File([JSON.stringify(newArr)], ""));
  axios.post(Api.uploadPattern, formData).then(function (res) {
      if(res.data && res.data.code === 0){
        //发送预览pattern的socket
        let type = SocketEvent.StartPreviewModeDTO;
        let data = { pattern:res.data.data.fileUrl,status:true, isDownload:true };
        socketServiceInstanct.socketEmitMsg(type, data);
        
        if (hasPattern) {//编辑
          editPattern(res.data.data.fileUrl)
        } else {//新增
          let osInfo = orderUtil.getOsInfo();
          let patternTotalTime = parseInt(newArr[newArr.length-1].t);
          let tFormat = FormatTime(patternTotalTime, "HH:mm:ss");
          let param = JSON.stringify({
            pattern: res.data.data.fileUrl,
            videoId: editorInfo.videoId,
            pf: editorInfo.pf,
            uid: editorInfo.uid,
            videoDuration: editorInfo.duration,
            videoUrl: window.location.href,
            name: "",
            duration: patternTotalTime,
            time: tFormat,
            videoName: "",
            system: osInfo.name + " " + osInfo.version,
            browser: osInfo.browser,
          });
          axios.post(Api.createPattern, param).then(function (res2) {
            if(res2.data && res2.data.code === 0){
              editorInfo.patternId = res2.data.data.id;
              createRecord('create_pattern_into')
              editPattern(res.data.data.fileUrl)
              socketServiceInstanct.socketEmitMsg(type, data);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        }
      }
  })
}
function setDiffTime(callback) {
    let url = process.env.REACT_APP_API_GETTIMESTAMP;
    //注：同步时间的这两个接口目前只能写死，需与app保持相同
    let localTimeStamp = (new Date()).getTime();
    // console.log("请求之前的本地时间：", localTimeStamp);
     axios.get(url).then(function(res){
        if(res.data.result){
        let localTimeStamp2 = (new Date()).getTime();
        // console.log("请求之后的本地时间：", localTimeStamp);
        let axiosRequestTime = parseInt((localTimeStamp2 - localTimeStamp)/2);
        // console.log("网络请求花费的时间：", axiosRequestTime);
        let serverTime = res.data.data;
        // console.log("服务器的时间：", serverTime);
        let localJzTime = localTimeStamp + axiosRequestTime;
        // console.log("本地时间与服务器时间校准后的时间：", localJzTime);
        let t = (serverTime - localJzTime); 
        callback(t);
        // console.log("本地与服务器的时间差异：", t);
        }
    })
};
function SetSocketService() {
      if(patternSocket &&  patternSocket.socketInstanceList && patternSocket.socketInstanceList.length>0){
        for(let i=0; i<patternSocket.socketInstanceList.length; i++){
          let item = patternSocket.socketInstanceList[i];
          if(item.videoId === editorInfo.videoId){
            hasRepeatSocket = true;
            socketServiceInstanct = item.socketService
            item.socketService.open()
          } else {
            item.socketService.close()
            patternSocket.socketInstanceList.splice(i, 1)
          }
        }
        if(!isConnect){
            clearInterval(getConnect)
            getConnect = setInterval(() => {
                if(isConnect) {
                    clearInterval(getConnect)
                    return
                }
                socketServiceInstanct.getSyncStatus();
                socketServiceInstanct.socketEmitMsg('ModifyVideoPatternDTO', {});
            }, 5000)
        }
      }
      if(!hasRepeatSocket){
        var formData = new FormData();
        formData.append('uid', editorInfo.uid);
        formData.append('pf', editorInfo.pf);
        formData.append('videoId', editorInfo.videoId);
        axios.post(Api.getToken, formData).then(function (res) {
          let data = res.data;
          if(data && data.code === 0){
            let socketIoPath = data.data.socketIoPath;
            let wsServerUrl = data.data.wsServerUrl;
            socketServiceInstanct = new SocketService();
            socketServiceInstanct.initSocket(wsServerUrl,socketIoPath);
            patternSocket.socketInstanceList.push({"videoId": editorInfo.videoId, "socketService": socketServiceInstanct});
            OnsocketServiceInstanct();
          }
        })
      }
}
function OnsocketServiceInstanct() {
    //监听socket消息
    if(socketServiceInstanct){
      if(!socketServiceInstanct._events.GetReadyPatternDTO){
        socketServiceInstanct.on(SocketEvent.GetReadyPatternDTO, getReadyPatternEvent);
      }
      if(!socketServiceInstanct._events.RemoteSyncStatusDTO){
        socketServiceInstanct.on(SocketEvent.RemoteSyncStatusDTO, getRemoteSyncStatusDTO);
      }
      if(!socketServiceInstanct._events.GetSyncStatusDTO){
        socketServiceInstanct.on(SocketEvent.GetSyncStatusDTO, getSyncStatusEvent);
      }
      if(!socketServiceInstanct._events.GetVideoProgressDTO){
        socketServiceInstanct.on(SocketEvent.GetVideoProgressDTO, getVideoProgressEvent);
      }
      if(!socketServiceInstanct._events.DisconnectPatternSyncDTO){
        socketServiceInstanct.on(SocketEvent.DisconnectPatternSyncDTO, disconnectPatternSyncEvent);
      }
      if(!socketServiceInstanct._events.ExitPatternSyncDTO){
        socketServiceInstanct.on(SocketEvent.ExitPatternSyncDTO, exitPatternSyncEvent);
      }
      if(!socketServiceInstanct._events.ErrorSyncPatternDTO){
        socketServiceInstanct.on(SocketEvent.ErrorSyncPatternDTO, ErrorSyncPatternEvent);
      }
      if(!socketServiceInstanct._events.SuccessDownloadPatternDTO){
        socketServiceInstanct.on(SocketEvent.SuccessDownloadPatternDTO, SuccessDownloadPatternEvent);
      }
    } 
    // return function(){
    //   if(socketServiceInstanct){
    //     socketServiceInstanct.off(SocketEvent.GetReadyPatternDTO, getReadyPatternEvent);
    //     socketServiceInstanct.off(SocketEvent.RemoteSyncStatusDTO, getRemoteSyncStatusDTO);
    //     socketServiceInstanct.off(SocketEvent.GetSyncStatusDTO, getSyncStatusEvent);
    //     socketServiceInstanct.off(SocketEvent.GetVideoProgressDTO, getVideoProgressEvent);
    //     socketServiceInstanct.off(SocketEvent.GetVideoProgressDTO, getSyncStatusEvent);
    //     socketServiceInstanct.off(SocketEvent.DisconnectPatternSyncDTO, disconnectPatternSyncEvent);
    //     socketServiceInstanct.off(SocketEvent.ExitPatternSyncDTO, exitPatternSyncEvent);
    //   }
    // }
}
function getReadyPatternEvent(data){
  let toysArr = [];
  let toysData = JSON.parse(data).toys;
  toysData.length&&toysData.forEach(item=>{
    item = JSON.parse(item)
    toysArr.push(item)
  })
  EventBind.emitEvent('remoteToyStatus',toysArr)
}
function getRemoteSyncStatusDTO(data){
  connectToyStatus = JSON.parse(data).status; 
  if (connectToyStatus === 3) {
    EventBind.emitEvent('remoteConnected')
  }
}
//查询当前用户的连接状态 1未连接 2连接中 3已连接
function getSyncStatusEvent(data){
  isConnect = true
  if(data.status === 3){
    // followStatus = true;
    connectToyStatus = 3;
  }else{
    // followStatus = false;
    connectToyStatus = 1;
  }
}
function getVideoProgressEvent() {
  let ts = (new Date().getTime()) + diffTime;
  let json = { videoTime:editorInfo.currentTime,speed:editorInfo.speed,localTime:ts };
  if (isPlay) {
    let type = SocketEvent.VideoProgressStatusDTO;
    socketServiceInstanct.socketEmitMsg(type, json);
  }
}
function disconnectPatternSyncEvent(data) {
  EventBind.emitEvent('remoteDisconnected')
}
function exitPatternSyncEvent(data) {
  EventBind.emitEvent('remoteExitPattern')
}
function ErrorSyncPatternEvent(data) {
  EventBind.emitEvent('PatternSyncError',data)
}
function SuccessDownloadPatternEvent(data) {
  EventBind.emitEvent('patternLoaded')
}
export default function ExportApi() {
  return{
    init:init,
    loadPattern:loadPattern,
    getApp:getApp,
    play:play,
    pause:pause,
    change:change,
    exit:exit,
    editInit:editInit,
    on:on,
    addEventListener:addEventListener,
  }
};